import ModelFactory from '../model-factory';

export default class Survey {
}

export const modelFactory = new ModelFactory('survey', (data) => new Survey(data));
